<template>
  <div class="container mt-8">
    <vs-card>
      <pre class="json">{{ blackList }}</pre>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: "ShowBlackList",
  data: () => ({
    blackList: null
  }),
  async mounted() {
    const { data }  = await axios.get('api/sitiaa/black-list/' + this.$route.params.blackListId)
    this.blackList = data;
  }
}
</script>
<style scoped>
.json {
    font-size: 1rem;
}
</style>